import React, { useEffect, useState } from "react";
import { db } from "../firebase";


import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";

import "./AdimnViewEndedMatches.css";

export default function AdminBetsRequest() {
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchMatch, setSearchMatch] = useState("");
  const [message, setMessage] = useState("");

  const fieldMap = {
    TZS: "tshBalance",
    USDT: "usdtBalance",
    KES: "KESBalance",
    UGX: "UGXBalance",
    RWF: "RWFBalance",
    BIF: "BIFBalance",
    ZMW: "ZMWBalance",
    MWK: "MWKBalance",
    MZN: "MZNBalance",
    USD: "USDBalance",
    SSP: "SSPBalance",
    BWP: "BWPBalance",
    MGA: "MGABalance",
  };

  useEffect(() => {
    fetchBets();
  }, []);

  async function fetchBets() {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, "antscore"));
      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setBets(list);
    } catch (error) {
      console.error(error);
      showMessage("Failed to load bets ❌");
    } finally {
      setLoading(false);
    }
  }

  const showMessage = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), 4000);
  };

  const formatDateTime = (timestamp) => {
    if (!timestamp) return "-";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return isNaN(date.getTime()) ? "-" : date.toLocaleString();
  };

  const getMatchDate = (bet) => {
    if (bet.matchTimestamp?.toDate) return bet.matchTimestamp.toDate();
    if (bet.matchTimestamp) return new Date(bet.matchTimestamp);
    if (bet.matchDate && bet.matchTime) {
        return new Date(`${bet.matchDate}T${bet.matchTime}`);
    }
    return null;
  };

  // Ended within last 3 hours (180 minutes)
  // Ionekane kuanzia dakika 70
const isVisibleBet = (bet) => {
    const matchDate = getMatchDate(bet);
    if (!matchDate) return false;
  
    const visibleTime = new Date(
      matchDate.getTime() + 70 * 60 * 1000
    );
  
    return new Date() >= visibleTime;
  };
  
  // Iruhusiwe kulipwa baada ya dakika 105
  const canPayBet = (bet) => {
    const matchDate = getMatchDate(bet);
    if (!matchDate) return false;
  
    const payTime = new Date(
      matchDate.getTime() + 105 * 60 * 1000
    );
  
    return new Date() >= payTime;
  };

  async function toggleBlock(bet) {
    try {
      await updateDoc(doc(db, "antscore", bet.id), {
        blockedPayout: !bet.blockedPayout,
      });
      showMessage(bet.blockedPayout ? "✅ User unblocked" : "🚫 User blocked from payout");
      fetchBets();
    } catch (err) {
      console.error(err);
      showMessage("Failed to update block ❌");
    }
  }

  async function handleWonBet(bet) {


    if (!canPayBet(bet)) {
        showMessage("⏳ Mechi bado haijafika dakika 105.");
        return;
      }

    if (bet.blockedPayout) {
      showMessage("🚫 User huyu ame-blockiwa payout");
      return;
    }
    if (bet.paidOut === true) {
      showMessage("⚠️ Tayari imelipwa");
      return;
    }
    if (bet.result) {
      showMessage("⚠️ Bet hii tayari ina result");
      return;
    }

    try {
      const q = query(collection(db, "users"), where("username", "==", bet.username));
      const snap = await getDocs(q);

      if (snap.empty) {
        showMessage("User not found ❌");
        return;
      }

      const userDoc = snap.docs[0];
      const userData = userDoc.data();
      const field = fieldMap[bet.currency];

      if (!field) {
        showMessage("Currency field not found ❌");
        return;
      }

      const payout = Number(bet.totalWin || 0);
      const currentBalance = Number(userData[field] || 0);

      await updateDoc(doc(db, "users", userDoc.id), {
        [field]: currentBalance + payout,
      });

      await updateDoc(doc(db, "antscore", bet.id), {
        result: "win",
        paidOut: true,
        paidAt: new Date(),
      });

      showMessage(`✅ ${bet.username} amelipwa ${payout}`);
      fetchBets();
    } catch (err) {
      console.error(err);
      showMessage("Error ❌");
    }
  }

  async function handleLost(bet) {


    if (!canPayBet(bet)) {
        showMessage("⏳ Mechi bado haijafika dakika 105.");
        return;
      }

    if (bet.result) {
      showMessage("⚠️ Bet hii tayari ina result");
      return;
    }

    try {
      await updateDoc(doc(db, "antscore", bet.id), {
        result: "lose",
        paidOut: false,
        lostAt: new Date(),
      });
      showMessage(`❌ ${bet.username} bet imewekwa LOST`);
      fetchBets();
    } catch (err) {
      console.error(err);
      showMessage("Failed to mark lost ❌");
    }
  }

  async function deleteBet(bet) {
    try {
      await deleteDoc(doc(db, "antscore", bet.id));
      showMessage("Bet deleted ✅");
      fetchBets();
    } catch (err) {
      console.error(err);
      showMessage("Failed to delete ❌");
    }
  }

  async function handleAllWon() {
    const pending = bets.filter(
        (b) =>
          canPayBet(b) &&
          !b.result &&
          !b.blockedPayout
      );
    if (pending.length === 0) {
      showMessage("⚠️ Hakuna bet inayofaa");
      return;
    }
    for (let bet of pending) await handleWonBet(bet);
    showMessage(`✅ ${pending.length} bets zimelipwa`);
  }

  async function handleAllLost() {
    const pending = bets.filter(
        (b) =>
          canPayBet(b) &&
          !b.result
      );
    if (pending.length === 0) {
      showMessage("⚠️ Hakuna bet inayofaa");
      return;
    }
    for (let bet of pending) await handleLost(bet);
    showMessage(`❌ ${pending.length} bets zimewekwa LOST`);
  }

  // Filtered bets (Last 3 hours only)
  const filtered = bets
  .filter((bet) => isVisibleBet(bet))
  .filter((bet) => !bet.result)
  .filter((bet) =>
    `${bet.teamA || ""} ${bet.teamB || ""} ${bet.username || ""}`
      .toLowerCase()
      .includes(searchMatch.toLowerCase())
  )
  .sort((a, b) => {
    const aReady = canPayBet(a);
    const bReady = canPayBet(b);

    // Zilizofika dakika 105 ziwe juu
    if (aReady && !bReady) return -1;
    if (!aReady && bReady) return 1;

    // Kisha zipangwe kwa muda wa mechi
    return getMatchDate(a) - getMatchDate(b);
  });

  const totalPlayers = filtered.length;
  const totalAmount = filtered.reduce((sum, bet) => sum + Number(bet.amount || 0), 0);
  const totalPossibleWin = filtered.reduce((sum, bet) => sum + Number(bet.totalWin || 0), 0);

  return (
    <div className="admin-ant-container">
      <h2>Admin Bets (AntScore - Ended Last 3 Hours)</h2>

      <input
        placeholder="Search match / user"
        value={searchMatch}
        onChange={(e) => setSearchMatch(e.target.value)}
      />

      {message && <p className="admin-message">{message}</p>}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "15px", margin: "20px 0" }}>
        <div className="summary-card">
          <h3>Total Ended Bets (Last 3 Hours)</h3>
          <p>{totalPlayers}</p>
        </div>
        <div className="summary-card">
          <h3>Total Amount</h3>
          <p>{totalAmount.toLocaleString()}</p>
        </div>
        <div className="summary-card">
          <h3>Total Possible Win</h3>
          <p>{totalPossibleWin.toLocaleString()}</p>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Bet ID</th>
                <th>Match</th>
                <th>League</th>
                <th>Match Time</th>
                <th>Bet Time</th>
                <th>Score</th>
                <th>Odds</th>
                <th>Amount</th>
                <th>TotalWin</th>
                <th>Currency</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan="12">
                    Hakuna bet iliyoisha ndani ya masaa 3 yaliyopita.<br />
                    (Jaribu kucheza mechi mpya)
                  </td>
                </tr>
              ) : (
                filtered.map((bet) => (
                  <tr key={bet.id}>
                    <td>{bet.username}</td>
                    <td>{bet.betId}</td>
                    <td>{bet.teamA} vs {bet.teamB}</td>
                    <td>{bet.league}</td>
                    <td>{formatDateTime(bet.matchTimestamp)}</td>
                    <td>{formatDateTime(bet.createdAt)}</td>
                    <td>{bet.score}</td>
                    <td>{bet.odds}</td>
                    <td>{bet.amount}</td>
                    <td>{bet.totalWin}</td>
                    <td>{bet.currency}</td>
                    <td className="actions-cell">

  <button
    className="won-btn"
    disabled={!canPayBet(bet)}
    onClick={() => handleWonBet(bet)}
  >
    {canPayBet(bet) ? "Won" : "Wait"}
  </button>

  <button
    className="lost-btn"
    disabled={!canPayBet(bet)}
    onClick={() => handleLost(bet)}
  >
    {canPayBet(bet) ? "Lost" : "Wait"}
  </button>

  <button
    className="block-btn"
    onClick={() => toggleBlock(bet)}
  >
    {bet.blockedPayout ? "Unblock" : "Block"}
  </button>

  <button
    className="delete-btn"
    onClick={() => deleteBet(bet)}
  >
    Delete
  </button>

</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>

<button
  className="won-btn"
  onClick={handleAllWon}
>
  🟢 All Won
</button>

<button
  className="lost-btn"
  onClick={handleAllLost}
>
  🔴 All Lost
</button>

</div>
        </>
      )}
    </div>
  );
}